import * as captainPayment from 'services/captainPayment';
import { createAction } from 'redux-actions';
import { CAPTAIN_PAYMENT as API } from 'apis';
import { getNotice, getNoticeByKey, getPushMessage, saveNotice, sendPushMessage, updateNotice } from 'apis/captainpayment/member';

export const CAPTAIN_PAYMENT = 'CAPTAIN_PAYMENT';
export const CAPTAIN_PAYMENT_PERMISSION = 'CAPTAIN_PAYMENT_PERMISSION';
export const CAPTAIN_PAYMENT_SIKDAE_PERMISSION = 'CAPTAIN_PAYMENT_SIKDAE_PERMISSION';
export const CAPTAIN_PAYMENT_SIKDAE_PERMISSION_DENIED = 'CAPTAIN_PAYMENT_SIKDAE_PERMISSION_DENIED';
export const CAPTAIN_PAYMENT_NOTICE_ADD = 'CAPTAIN_PAYMENT_NOTICE_ADD';
export const CAPTAIN_PAYMENT_NOTICE_LIST = 'CAPTAIN_PAYMENT_NOTICE_LIST';
export const CAPTAIN_PAYMENT_NOTICE_MOD = 'CAPTAIN_PAYMENT_NOTICE_MOD';
export const CAPTAIN_PAYMENT_NOTICE_SEL = 'CAPTAIN_PAYMENT_NOTICE_SEL';
export const CAPTAIN_PAYMENT_PUSH_ADD = 'CAPTAIN_PAYMENT_PUSH_ADD';
export const CAPTAIN_PAYMENT_PUSH_LIST = 'CAPTAIN_PAYMENT_PUSH_LIST';

export const getCaptainPaymentMe = () => ({
  type: CAPTAIN_PAYMENT,
  payload: {
    promise: API.getMeInfo()
  }
});

export const captainPaymentAuth = (menuIdx) => ({
  type: CAPTAIN_PAYMENT_PERMISSION,
  payload: {
    promise: captainPayment.getPermission(menuIdx)
  }
});

export const captainPaymentSikdaePermission = (params) => ({
  type: CAPTAIN_PAYMENT_SIKDAE_PERMISSION,
  payload: {
    promise: API.getSikdaePermission(params)
  }
});

export const setSikdaePermission = createAction(CAPTAIN_PAYMENT_SIKDAE_PERMISSION_DENIED);

// 대장마켓플레이스 임시 Action
export const CAPTAIN_DIVISIONS = 'CAPTAIN_DIVISIONS';
export const CAPTAIN_DIVISION_ADD = 'CAPTAIN_DIVISION_ADD';
export const CAPTAIN_DIVISION_MOD = 'CAPTAIN_DIVISION_MOD';
export const CAPTAIN_DIVISION_DEL = 'CAPTAIN_DIVISION_DEL';
export const CAPTAIN_DIVISIONS_L = 'CAPTAIN_DIVISIONS_L';
export const CAPTAIN_DIVISION_USER_COUNT = 'CAPTAIN_DIVISION_USER_COUNT';

export const getDivisionList = (params) => ({
  type: CAPTAIN_DIVISIONS,
  payload: {
    promise: API.getDivision(params)
  }
});

export const addDivision = (params) => ({
  type: CAPTAIN_DIVISION_ADD,
  payload: {
    promise: API.addDivision(params)
  }
});

export const modifySortDivision = (params) => ({
  type: CAPTAIN_DIVISION_MOD,
  payload: {
    promise: API.modifyDivision(params)
  }
});

export const removeDivision = (params) => ({
  type: CAPTAIN_DIVISION_DEL,
  payload: {
    promise: API.removeDivision(params)
  }
});

export const getDivisionCount = (params) => ({
  type: CAPTAIN_DIVISION_USER_COUNT,
  payload: {
    promise: API.getDivisionCount(params)
  }
});

export const setDivisions = createAction(CAPTAIN_DIVISIONS_L);

// 회사 공지사항 목록
export const NoticeList = (params) => ({
  type: CAPTAIN_PAYMENT_NOTICE_LIST,
  payload: {
    promise: getNotice(params)
  }
});

// 회사 공지사항 등록
export const NoticeAdd = (params) => ({
  type: CAPTAIN_PAYMENT_NOTICE_ADD,
  payload: {
    promise: saveNotice(params)
  }
});

// 회사 공지사항 상세
export const NoticeDtl = (id) => ({
  type: CAPTAIN_PAYMENT_NOTICE_SEL,
  payload: {
    promise: getNoticeByKey(id)
  }
});

// 회사 공지사항 수정
export const NoticeMod = (id, params) => ({
  type: CAPTAIN_PAYMENT_NOTICE_MOD,
  payload: {
    promise: updateNotice(id, params)
  }
});

// 푸쉬 목록
export const PushMessageList = (params) => ({
  type: CAPTAIN_PAYMENT_PUSH_LIST,
  payload: {
    promise: getPushMessage(params)
  }
});

// 푸쉬 등록
export const PushMessageAdd = (params) => ({
  type: CAPTAIN_PAYMENT_PUSH_ADD,
  payload: {
    promise: sendPushMessage(params)
  }
});
